
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  selectedService: [],
  general_category_id: "",
  service_count: 0,
  total_amount: 0,
};

const serviceSlice = createSlice({
  name: "services",
  initialState,
  reducers: {
    addOrRemoveService: (state, action) => {
      const item = action.payload;
 
      if (!state.general_category_id) {
        state.general_category_id = item.general_category_id;
      }
 
      if (state.general_category_id !== item.general_category_id) {
        toast("Please select one category service at a time", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: "light",
          className: "text-danger toast-style-1",
        });
        return;
      }

      const existingIndex = state.selectedService.findIndex(
        (service) => service.service_id === item.service_id
      );
 
      if (existingIndex !== -1) {
        state.selectedService.splice(existingIndex, 1);
      } else {
        state.selectedService.push({
          service_id: item.service_id,
          service_type: item.service_type,
          service_name: item.service_name,
          price: item.service_price,
        });
      }
 
      state.service_count = state.selectedService.length;
      state.total_amount = state.selectedService.reduce(
        (acc, service) => acc + Number(service.price || 0),
        0
      );
 
      if (state.service_count === 0) {
        state.general_category_id = "";
      }
 
      localStorage.setItem("serviceAdded", JSON.stringify(state));
    },
 
    loadServicesFromStorage: (state) => {
      const saved = JSON.parse(localStorage.getItem("serviceAdded") || "{}");
      if (saved.selectedService) {
        return saved;
      }
    },

    clearServices: (state) => {
      state.selectedService = [];
      state.general_category_id = "";
      state.service_count = 0;
      state.total_amount = 0;
      localStorage.removeItem("serviceAdded");
    },
  },
});

export const {
  addOrRemoveService,
  loadServicesFromStorage,
clearServices,} = serviceSlice.actions;

export default serviceSlice.reducer;
